/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export const BUILD_TIMESTAMP = new InjectionToken<typeof environment.buildTimestamp>('buildTimestamp');
